import React from 'react';

import { Container } from './Card.styles';
import { CardProps } from './Card.types';

const Card: React.FC<CardProps> = ({ style, width, height, hoverable, children }) => (
  <Container data-testid="card" style={style} width={width} height={height} hoverable={hoverable}>
    {children}
  </Container>
);

export default Card;
